"use client";
import { useRive, Layout, Fit, Alignment } from "@rive-app/react-canvas";

export const VindLoader = ({ width = 163, height = 131 }) => {
  const { RiveComponent } = useRive({
    src: "/vindloading.riv",
    autoplay: true,
    useOffscreenRenderer: true,
    layout: new Layout({
      fit: Fit.Cover,
      alignment: Alignment.Center,
    }),
    enableRiveAssetCDN: false,
  });
  return (
    <div
      style={{
        width,
        height,
      }}
      className=" relative z-10"
    >
      <RiveComponent className="" />
    </div>
  );
};

export default VindLoader;
